export const hideEmailDetails = (str: string) => {
  const positionOfAt = str.indexOf('@');
  return positionOfAt < 4
    ? `${'•'.repeat(positionOfAt)}${str.slice(str.indexOf('@'))}`
    : `${str.slice(0, 2) + '•'.repeat(positionOfAt - 2)}${str.slice(
        str.indexOf('@')
      )}`;
};
